import React, { useEffect, useState } from 'react'
import { getChosung } from '../util/getChosung' // 경로는 프로젝트에 맞게 확인
import styled from 'styled-components'
import SearchIcon from '../asset/SearchIcon' // 경로는 프로젝트에 맞게 확인
import { DocumentNode } from 'graphql'
import { gql, useQuery } from '@apollo/client'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  background-color: #fff;

  min-width: 210px;
  flex-shrink: 0;
  max-height: 100%;
  overflow: hidden;
`

const Head = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #373a40;
  gap: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
`

const RegisterButton = styled.div`
  display: flex;
  height: 25px;
  padding: 4px 8px 4px 8px;
  border-radius: 4px;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const RegisterButtonText = styled.span`
  font-family: SUIT;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
`

const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #373a40;
  height: 21px;
  gap: 4px;
`

const SearchInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const SearchInput = styled.input`
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 16px;
  width: 100%;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #b3b3b3;
  }
`

const SearchLine = styled.div`
  width: 100%;
  border: 1px solid #b3b3b3;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px;
  overflow-y: auto;
  /* 스크롤바 스타일링 (선택) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }
`

export const SearchListWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  max-height: 100%;
  min-height: 0;
`

interface SearchItemProps {
  selected?: boolean
}

const SearchItemList = styled.div<SearchItemProps>`
  display: flex;
  flex-direction: column;
  padding: 12px 8px; /* 터치 영역 확보를 위해 패딩 조정 */
  border-radius: 6px;
  gap: 4px;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? '#F0F2F7' : 'transparent')};
  &:hover {
    background-color: #f5f5f5;
  }
`

const SearchItemName = styled.div`
  font-family: SUIT;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  color: #333333;
`

const SearchItemDescription = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #777777;
`

interface Props {
  title?: string
  placeholder?: string
  onReset?: Function
  onEvent?: Function
  findOne?: Function
  setPageData?: Function // 이제 사용하지 않더라도 호환성을 위해 유지하거나 제거 가능
  setIsCheck?: Function
  findAllListgql?: DocumentNode
  setRefetch?: (ListRefetch: () => void) => void
  nameKey?: string // [중요] 필드명 동적 지정을 위한 Prop 추가
  descriptionRenderer?: (item: any) => React.ReactNode
}

const SearchList = (props: Props) => {
  const {
    title,
    placeholder,
    onReset,
    onEvent,
    findOne,
    // setPageData, // CustomerESS 로직상 여기서 setPageData를 직접 부를 필요가 없음
    setIsCheck,
    findAllListgql,
    setRefetch,
    nameKey = 'name', // 기본값은 'name'으로 설정 (ESS에서는 'ESS_name'을 넣어야 함)
    descriptionRenderer,
  } = props

  const [searchTerm, setSearchTerm] = useState('')
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [filteredList, setFilteredList] = useState<any[]>([])

  // GraphQL Query
  const {
    data: originList,
    error,
    refetch: listRefetch,
  } = useQuery(
    findAllListgql || gql``,
    { fetchPolicy: 'network-only' } // 항상 최신 목록 조회
  )

  const [List, setList] = useState<any[]>([])

  // 리스트 리프레시 함수 상위 전달
  useEffect(() => {
    if (setRefetch) setRefetch(() => listRefetch)
  }, [listRefetch, setRefetch])

  // 데이터 로드 시 리스트 세팅
  useEffect(() => {
    if (originList) {
      // GQL 응답 구조가 { findAllESS: [...] } 형태이므로 첫 번째 키의 값을 가져옴
      const keys = Object.keys(originList)
      if (keys.length > 0) {
        const listData = originList[keys[0]]
        if (Array.isArray(listData)) {
          setList(listData)
        }
      }
    }
  }, [originList])

  useEffect(() => {
    if (error) {
      console.error(`${title || '목록'} 조회 실패`, error)
    }
  }, [error, title])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  const handleItemClick = (item: any) => {
    setSelectedItem(item)
    console.log('item', item)

    if (setIsCheck) setIsCheck(true)

    if (findOne && item._id) {
      findOne({
        variables: {
          val: item._id,
        },
      })
    }
  }

  const handleRegister = () => {
    setSelectedItem(null)
    if (setIsCheck) setIsCheck(false)
    if (onReset) onReset()
    if (onEvent) onEvent()
  }

  // 검색어 필터링 로직
  useEffect(() => {
    if (Array.isArray(List)) {
      setFilteredList(
        List.filter((item: any) => {
          // 동적 필드명(nameKey) 사용
          const itemName = item[nameKey] || ''
          const itemDescription = descriptionRenderer?.(item)
          const descriptionText =
            typeof itemDescription === 'string' ? itemDescription : ''
          const searchTarget = `${itemName} ${descriptionText}`

          if (!itemName) return false

          if (searchTerm?.length === 1 && /[ㄱ-ㅎ]/.test(searchTerm)) {
            // 초성 검색
            const firstCharChosung = getChosung(itemName[0])
            return firstCharChosung === searchTerm
          } else {
            // 일반 검색
            return searchTarget.toLowerCase().includes(searchTerm.toLowerCase())
          }
        })
      )
    }
  }, [List, searchTerm, nameKey, descriptionRenderer])

  return (
    <Wrapper>
      <Head>
        <TitleWrapper>
          <Title>{title || '목록'}</Title>
          <RegisterButton onClick={handleRegister}>
            <RegisterButtonText>등록</RegisterButtonText>
          </RegisterButton>
        </TitleWrapper>
        <SearchHeader>
          <SearchInputWrapper>
            <SearchInput
              type="text"
              placeholder={placeholder || '이름을 입력하세요'}
              value={searchTerm}
              onChange={handleChange}
            />
            <SearchIcon />
          </SearchInputWrapper>
          <SearchLine />
        </SearchHeader>
      </Head>
      <Body>
        {filteredList.map((item, index) => (
          <SearchItemList
            key={item._id || index}
            selected={selectedItem?._id === item._id}
            onClick={() => handleItemClick(item)}
          >
            {/* 동적 필드명으로 렌더링 */}
            <SearchItemName>{item[nameKey]}</SearchItemName>
            {descriptionRenderer && (
              <SearchItemDescription>
                {descriptionRenderer(item)}
              </SearchItemDescription>
            )}
          </SearchItemList>
        ))}
      </Body>
    </Wrapper>
  )
}

export default SearchList
